// src/Payroll_Management/PayRoll_Report/EmployeeLicenseReportPrint.jsx
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://nissi-india.com";

function s(v) {
  return (v ?? "").toString().trim();
}

const EmployeeLicenseReportPrint = () => {
  const finYearId = localStorage.getItem("finYearId") || "";

  // ASP Print uses Session values:
  // licbranchid, licgrade, licdept, licdesig, licpfornonpf, licpaymode, licempcode, licempnme, licbrtype
  // In React we pass them as query params to print page.
  const location = useLocation();
  const qs = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const params = useMemo(
    () => ({
      licbranchid: s(qs.get("licbranchid") || qs.get("branchId") || qs.get("branch") || "Select"),
      licgrade: s(qs.get("licgrade") || qs.get("grade") || "Select"),
      licdept: s(qs.get("licdept") || qs.get("dept") || "Select"),
      licdesig: s(qs.get("licdesig") || qs.get("desig") || "Select"),
      licpfornonpf: s(qs.get("licpfornonpf") || qs.get("pf") || "Select"),
      licpaymode: s(qs.get("licpaymode") || qs.get("paymode") || "Select"),
      licempcode: s(qs.get("licempcode") || qs.get("empcode") || ""),
      licempnme: s(qs.get("licempnme") || qs.get("empname") || ""),
      licbrtype: s(qs.get("licbrtype") || qs.get("branchType") || ""),
      // optional display value
      branchName: s(qs.get("branchName") || qs.get("branchText") || ""),
    }),
    [qs]
  );

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // Company header (fallback text; you can wire a real API later)
  const [company] = useState({
    name: "Nissi Infotech",
    subtitle1: "Nissi",
    subtitle2: "CIVIL CONSTRUCTION",
    address: "3/42-12, Nagappa colony, kavundampalayam",
    city: "Coimbatore - 641030 . Tamil Nadu. India.",
    phone: "Phone No : 9003744644",
    website: "infraconsoft-implementation",
  });

  const fetchPrintData = async () => {
    if (!String(finYearId).trim()) return;

    try {
      setLoading(true);

      // ✅ This endpoint should return full dataset (no pagination)
      // Recommended Node endpoint:
      // GET /api/employee-license-renewal/print-data?finYearId=..&licbranchid=..&licgrade=.. etc
      const res = await axios.get(`${BASE_URL}/api/employee-license-renewal/print-data`, {
        params: {
          finYearId: Number(finYearId),
          ...params,
        },
      });

      if (res?.data?.success) {
        setRows(res.data.rows || []);
      } else {
        setRows([]);
      }
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // auto print when loaded
  useEffect(() => {
    if (!loading) {
      const t = setTimeout(() => window.print(), 350);
      return () => clearTimeout(t);
    }
  }, [loading]);

  const branchLine = params.branchName
    ? params.branchName
    : params.licbranchid && params.licbranchid !== "Select"
    ? `Branch ID : ${params.licbranchid}`
    : "Branch : All";

  return (
    <div className="print-wrap">
      <style>{`
        @page { size: A4; margin: 10mm; }
        * { box-sizing: border-box; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .print-wrap { font-family: Arial, Helvetica, sans-serif; color:#000; }

        .toolbar {
          display:flex; gap:10px; margin:0 0 10px 0;
        }
        .btn {
          border:1px solid #111; background:#111; color:#fff;
          padding:10px 14px; border-radius:10px; cursor:pointer; font-weight:800;
        }
        .btn.secondary { background:#fff; color:#111; }

        .page { width:100%; border:2px solid #000; padding:10px; }
        .inner { border:1px solid #000; padding:10px; }

        .headerBox{
          border:1px solid #000;
          padding:10px;
          display:grid;
          grid-template-columns: 90px 1fr 90px;
          align-items:center;
          gap:10px;
        }
        .logo{
          width:90px; height:70px;
          display:flex; align-items:center; justify-content:center;
          font-size:11px; font-weight:900;
        }
        .titleArea{ text-align:center; line-height:1.2; }
        .titleArea .name{ font-weight:800; font-size:20px; }
        .titleArea .sub{ font-weight:700; font-size:12px; }
        .titleArea .addr{ font-size:11px; }
        .spacerBox{ width:90px; height:70px; }

        .reportTitle{
          margin-top:10px;
          text-align:center;
          font-weight:900;
          font-size:14px;
          padding:8px 0;
          border-left:1px solid #000;
          border-right:1px solid #000;
          border-bottom:1px solid #000;
        }

        .branchLine{
          border-left:1px solid #000;
          border-right:1px solid #000;
          border-bottom:1px solid #000;
          padding:8px 10px;
          font-weight:800;
          font-size:12px;
        }

        table.report{
          width:100%;
          border-collapse:collapse;
          font-size:12px;
          margin-top:0px;
        }
        table.report th, table.report td{
          border:1px solid #000;
          padding:8px 6px;
          vertical-align:middle;
        }
        table.report th{
          font-weight:900;
          text-align:center;
        }
        .center{ text-align:center; }
        .left{ text-align:left; }
        .noData{
          padding:18px;
          text-align:center;
          font-weight:800;
        }

        @media print { .toolbar{ display:none; } }
      `}</style>

      <div className="toolbar">
        <button className="btn" onClick={() => window.print()}>
          Print
        </button>
        <button className="btn secondary" onClick={() => window.close()}>
          Close
        </button>
      </div>

      <div className="page">
        <div className="inner">
          {/* Header */}
          <div className="headerBox">
            <div className="logo">
              {/* Replace with your real logo:
                  <img src="/assets/nissi-logo.png" alt="logo" style={{width:'100%',height:'100%',objectFit:'contain'}} />
              */}
              LOGO
            </div>

            <div className="titleArea">
              <div className="name">{company.name}</div>
              <div className="sub">{company.subtitle1}</div>
              <div className="sub">{company.subtitle2}</div>
              <div className="addr">{company.address}</div>
              <div className="addr">{company.city}</div>
              <div className="addr">{company.phone}</div>
              <div className="addr">{company.website}</div>
            </div>

            <div className="spacerBox" />
          </div>

          <div className="reportTitle">EMPLOYEE LICENSE RENEWAL REPORT</div>
          <div className="branchLine">{branchLine}</div>

          <table className="report">
            <thead>
              <tr>
                <th style={{ width: "60px" }}>S.No</th>
                <th style={{ width: "110px" }}>EMP Code</th>
                <th style={{ width: "160px" }}>EMP Name</th>
                <th style={{ width: "150px" }}>Designation</th>
                <th style={{ width: "170px" }}>Driving License No.</th>
                <th style={{ width: "150px" }}>Driving License Expire Date</th>
                <th style={{ width: "140px" }}>Other Expire Date</th>
                <th style={{ width: "130px" }}>Branch</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={8} className="noData">
                    {loading ? "Loading..." : "No Records Found"}
                  </td>
                </tr>
              ) : (
                rows.map((r, idx) => (
                  <tr key={`${r.fld_employeeid ?? r.fld_employeecode ?? idx}-${idx}`}>
                    <td className="center">{idx + 1}</td>
                    <td className="center">{r.fld_Employeecode}</td>
                    <td className="left">{r.fld_Employee}</td>
                    <td className="center">{r.fld_designationname}</td>
                    <td className="center">{r.fld_drivinglicnum}</td>
                    <td className="center">{r.fld_drivinglicexpdate}</td>
                    <td className="center">{r.fld_otherexpirydate}</td>
                    <td className="center">{r.fld_BranchName}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div style={{ height: 10 }} />
        </div>
      </div>
    </div>
  );
};

export default EmployeeLicenseReportPrint;
